import getIsAndroid from "selectors/device/getIsAndroid";
import getUseCanvasVideo from "selectors/device/getUseCanvasVideo";
import { createSelector } from "reselect";

const getForceMute = (_, ownProps) => !!ownProps.forceMute;

const getUsePlaybackResumeDelay = createSelector(
  getForceMute,
  getIsAndroid,
  getUseCanvasVideo,
  (forceMute, isAndroid, useCanvasVideo) =>
    isAndroid || (forceMute && useCanvasVideo),
);

export default getUsePlaybackResumeDelay;
